export const CouponTargetGroup = Object.freeze({
  B2B: 'B2B',
  B2C: 'B2C',
  NONE: 'NONE',
})
